
export interface CfPopoverInterface {
  onWillDismiss(data: any): void;

  afterAnimationFinished(): void;
}

export class CfPopoverBase implements CfPopoverInterface {
  onWillDismiss(data: any) {
    void data;
    throw new Error("Method not implemented.");
  }
  afterAnimationFinished(): void {
    // Custom logic after animation finishes
  }
}
